import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { PRODUCT, questions } from '../data/content';
export function ProblemSection() {
  return <section aria-labelledby="problema" className="border-y-2 border-blush bg-blush-soft" data-id="element-158" data-mp="30gxuvzkkxjnt">
      <div className="mx-auto max-w-page px-3 py-6 text-center sm:px-6 sm:py-8" data-id="element-159" data-mp="2vpzcmug16bhx">
        <Reveal data-id="element-160" data-mp="39hvzaiyxjt6x">
          <h2 id="problema" className="mx-auto max-w-3xl font-display text-lg font-black uppercase leading-[1.08] text-ink sm:text-2xl lg:text-3xl" data-id="element-161" data-mp="39hcrhv2zul6m">
            ¿Y si en lugar de aprender palabras sueltas tuvieras una ruta clara
            desde el primer día?
          </h2>
          <p className="mx-auto mt-1.5 max-w-2xl text-[0.8rem] font-bold text-coral sm:text-sm" data-id="element-162" data-mp="3egpc096e7g61">
            Tienes las ganas de aprender coreano. Pero probablemente también
            tengas muchas preguntas.
          </p>
        </Reveal>

        <ul className="mx-auto mt-3 grid max-w-4xl gap-1.5 sm:grid-cols-2" data-id="element-163" data-mp="1k52ay4wwqjh7">
          {questions.map((q, i) => <Reveal key={q} as="li" delay={i * 0.03} className="flex items-center gap-2 rounded-lg border border-blush bg-white px-2.5 py-2 text-left font-body text-[0.78rem] font-semibold text-ink sm:text-[0.82rem]" data-id="element-164" data-mp="jbahpax59vkh" data-mpi={i}>
              <HelpCircleIcon size={15} className="flex-shrink-0 text-coral" strokeWidth={2.5} data-id="element-165" data-mp="x6ml06pd8ud0" />
              {q}
            </Reveal>)}
        </ul>

        <Reveal delay={0.08} className="mx-auto mt-4 max-w-3xl" data-id="element-166" data-mp="1c226vofsljyb">
          <p className="font-body text-[0.8rem] leading-snug text-slate sm:text-sm" data-id="element-167" data-mp="1c2k9d2t1sueo">
            El problema no siempre es la falta de información.{' '}
            <span className="font-bold text-ink" data-id="element-168" data-mp="3dtxg7xektcdd">
              Es que hay demasiada información dispersa y pocas rutas claras
              para el principiante.
            </span>
          </p>
          <p className="mt-1.5 font-body text-[0.8rem] leading-snug text-slate sm:text-sm" data-id="element-169" data-mp="ozqysdpitzyp">
            {PRODUCT} reúne los conocimientos fundamentales en una secuencia
            diseñada para llevarte desde el Hangul hasta tus primeras frases,
            situaciones cotidianas y expresiones frecuentes.
          </p>
          <p className="mt-2 font-script text-2xl text-coral sm:text-3xl" data-id="element-170" data-mp="tykac0l8zgw8">
            Lee. Reconoce. Construye. Comunica.
          </p>
        </Reveal>
      </div>
    </section>;
}